import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { endpoints } from 'apps/portal/online/services/core/apiConfig';
import { MenuPageDataType } from '../../(routes)/online-ordering/types';

// Define a service using a base URL and expected endpoints
// You can import or define the base URL like this:
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string;

export const menuApi = createApi({
  reducerPath: 'menuApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${baseUrl}` }),
  endpoints: (build) => ({
    getTags: build.query<any, { restaurantId: number; menuId: number }>({
      query: ({ restaurantId, menuId }) => `${endpoints.menu.getTags}?restaurantId=${restaurantId}&menuId=${menuId}`,
    }),
    getAllergens: build.query<any, { restaurantId: number; menuId: number }>({
      query: ({ restaurantId, menuId }) =>
        `${endpoints.menu.getAllergens}?restaurantId=${restaurantId}&menuId=${menuId}`,
    }),
    getOverallFilteredItems: build.query<any, { restaurantId: number }>({
      query: ({ restaurantId }) => `${endpoints.menu.getSearchItems}?restaurantId=${restaurantId}`,
    }),
    getRestaurantMenuData: build.query<MenuPageDataType, { restaurantId: number; businessId: number }>({
      query: ({ restaurantId, businessId }) => {
        return {
          url: `${endpoints.menu.getCompleteMenu}?restaurantId=${restaurantId}&businessId=${businessId}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => response?.data,
    }),
    validateMenuData: build.query<boolean, { restaurantId: number; businessId: number; menuVersion: string }>({
      query: ({ restaurantId, businessId, menuVersion }) => {
        return {
          url: `${endpoints.menu.validateMenuVersion}?restaurantId=${restaurantId}&businessId=${businessId}&menuVersion=${menuVersion}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => {
        return response?.data?.status ?? false;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTagsQuery,
  useGetAllergensQuery,
  useGetOverallFilteredItemsQuery,
  useGetRestaurantMenuDataQuery,
  useValidateMenuDataQuery,
} = menuApi;
